import type { IntegrationApp } from '../integration-apps';

/** 40px grey tile with the app icon, shared by connected rows and available cards. */
export function AppIconTile({ icon: AppIcon }: Pick<IntegrationApp, 'icon'>) {
  return (
    <span className="flex size-10 shrink-0 items-center justify-center rounded-card bg-grey-100 text-grey-900 dark:bg-muted dark:text-foreground">
      <AppIcon width={18} height={18} strokeWidth={1.5} />
    </span>
  );
}
